import React from "react";
import internet from "../../img/undraw_page_not_found_re_e9o6.svg";
import "./notfound.css";
const Notfound = () => {
  return (
    <div className="internet">
      <h2>هذه الصفحة غير موجوده</h2>

      <img src={internet} alt="internet" />
    </div>
  );
};

export default Notfound;
